export default {
	importStaffWorkScheduleForShop (params = new URLSearchParams()) {
		let config = {
			headers: {
				'content-type': 'multipart/form-data'
			}
		}
		return Axios.post(API_BASE + 'import/staff_work_schedule/shop', params, config)
	},
	importStaffWorkScheduleForMainOffice (params = new URLSearchParams()) {
		let config = {
			headers: {
				'content-type': 'multipart/form-data'
			}
		}
		return Axios.post(API_BASE + 'import/staff_work_schedule/main_office', params, config)
	},
	importPw (params = new URLSearchParams()) {
		let config = {
			headers: {
				'content-type': 'multipart/form-data'
			}
		}
		return Axios.post(API_BASE + 'import/password/cgt_manage', params, config)
	}
}



// WEBPACK FOOTER //
// ./src/api/CsvImport.js